import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Toolbar, Grid, Button, Card, CardContent } from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import KisshtTable from "components/table/KisshtTable";
import { RobotFont } from "components/ui/RobotFont";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { PERMISSIONS, ROUTE_NAME } from 'shared/constants';
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CustomSelect from "components/custom/CustomSelect";
import PinCodeViewModel from "./dialog/pincodeViewModel";
import AddEditPinModel from "./dialog/addEditPinModel";
import KisshtButton from 'components/ui/KisshtButton';
import { pinCodeListing } from "shared/api/pincodelist";
import PermissionButton from 'components/ui/form/PermissionButton';
import AddIcon from '@material-ui/icons/Add';
import {filterValidation} from '../../../shared/utils'

let offset = 1;
export const PincodeList = (props) => {
  
  const [openPincode, setPincode] = useState(false);
  const { params, updateQueryParams, delteQueryParams } = props;
  const [search, setSearch] = useState("");
  const [spinning, setSpinning] = useState(false);
  const [pinData, setPinData] = useState([]);
  const [pinDataCount, setPinDataCount] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [showPinData,setShowPinData] = useState(null)
  const [openPinCodeModal,setPinCodeModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(params["selectedFilter"] || "");
  const [errorMessage, setErrorMessage] = useState("");


  const fetchPinCodeListing = async () => {
    setSpinning(true);
    await updateQueryParams({ search });
    let data = getParam();
    pinCodeListing(data)
      .then((res) => {
        setSpinning(false);
        setPinData([]);
        if (res.hasOwnProperty("success") && res.success) {
                    if (res?.data?.list?.length > 0) {
                      setPinData(res?.data?.list);
                      setPinDataCount(res?.data?.count);
          } else {
            setPinData([]);
          }
        }
      })
      .catch((error) => {
        setPinData([]);
        setSpinning(false);
      });
  };
    const getParam = (_) => {
       
        let data = {
          "limit":20,
          "offset":offset - 1,
        };
       if(search){   
         if(selectedFilter === "state_name"){
          data = {
            "limit":20,
            "offset":offset - 1,
            "state_name" : search
          }
         }  
         else 
         if(selectedFilter === "city_name"){
          data = {
            "limit":20,
            "offset":offset - 1,
            "city_name" : search
          }
         } 
         else
         {
        data = {
          "limit":20,
          "offset":offset - 1,
          "pincode" : search
        }
      }
       }
       return data;
     };


  useEffect(() => {
      fetchPinCodeListing();
      offset = 1;
  }, [reload]);

  const editClickHandler = async (cell) => {
    
     setEditData(cell.original);
     setisEditing(true);
     setPincode(true);
  };


  const columns = [
    {
      Header: "Pin Code",
      accessor: "pincode",
      sortable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
        return <RobotFont type="medium">{cell.value}</RobotFont>
      },

      headerStyle: {
      },
      filterable: false,
    },
    {
      Header: "City Name	",
      accessor: "city_name",
      sortable: false,
      filterable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
      return<RobotFont type="medium">{cell.value}</RobotFont>
      }
    },
    {
      Header: "State Name	",
      accessor: "state_name",
      filterable: false,
      sortable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
      return <RobotFont type="medium">{cell.value}</RobotFont>
    }
    },
    {
      Header: "Is Purple Active	",
      accessor: "is_purple_active",
      filterable: false,
      sortable: false,
      Cell: (cell) => {
        return <span>{cell.value === 1 ? "YES" : "NO"}</span>
      },
    },
    {      

      Header: "Is Active	",
      accessor: "is_active",
      filterable: false,
      sortable: false,
      Cell: (cell) => {
        return <span>{cell.value === "1" ? "YES" : "NO"}</span>
      },
    },
    {
      Header: "Action",
      accessor: "id",
      filterable: false,
      sortable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
        return (
          <Grid container spacing={1} className="space_btn_table">
            <Grid item >
            <PermissionButton
              endIcon={<VisibilityIcon />}
              size="small"
              variant="outlined"
              style={{border:'none'}}
              route={ROUTE_NAME.pincode}
              permission={PERMISSIONS.pincode.pincode_view}
              onClick={() => showPinCodeModel(cell)}></PermissionButton>
            </Grid>
            <Grid item >
            <PermissionButton
              endIcon={<EditIcon />}
              size="small"
              variant="outlined"
              style={{border:'none'}}
              route={ROUTE_NAME.pincode}
              permission={PERMISSIONS.pincode.pincode_update}
              onClick={() => editClickHandler(cell)}></PermissionButton>
            </Grid>
          </Grid>
        );
      },
    }
  ];

  const handleSelect = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setSearch("");
        await delteQueryParams();
        setReload(!reload);
      }
      setSelectedFilter(item);
      setSearch("");
    }
  };
  
  const OnHandleSearch = (e) => {    
    const validation_msg = filterValidation(selectedFilter,e.target.value)
    setSearch(e.target.value)
    setErrorMessage(validation_msg)
  }
  
  const refreshHandler = async (_) => {
    setSearch("");
    setSelectedFilter("");
    await delteQueryParams();
    offset = 1;
    setReload(!reload);
  };

  const handlePinCodeModalClosed = (sts) => {
    if (sts) {
        setPinCodeModal(false);
    } else {
      setPinCodeModal(sts);
    }
  };
  const showPinCodeModel = async (cell) => {
     setShowPinData(cell.original);

     setPinCodeModal(true);        
  };
  
  const onPageChange = (value) => {
    offset = value;
    fetchPinCodeListing();
  };


  const handleToggleDialogClose = () => {
    fetchPinCodeListing();
    setPincode(false)
  }
 const handleDialogClick = () =>{
  setPincode(false)
}


const handleSearch = async (e) => {
  e.preventDefault();
  if (!search.length){
    return false;
  }
  setSpinning(true);
  offset = 1;
  updateQueryParams({search});
  fetchPinCodeListing();
};
return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center" className="crum_padding">
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
              <Grid item lg={3} md={3} sm={4} xs={4}>
                  <BreadcrumbsHeader text="Pincode List" />
              </Grid>
              <Grid item lg={9} md={9} sm={8} xs={12} className='top_spacing_btn'>
                <Grid container justifyContent="flex-end">
                <Grid item>
                    <KisshtButton
                      startIcon={<AddIcon />}
                      size="small"
                      variant="contained"
                      style={{border:'none'}}
                      route={ROUTE_NAME.pincode}
                      permission={PERMISSIONS.pincode.pincode_create}
                      onClick={()=>{setisEditing(false);
                        setPincode(true)}}
                      className="common_kissht_btn"
                    >Add New</KisshtButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>  
            <Grid item xs={12} className="crum_innerPadding">
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                <CustomSelect
                    width="100px"
                    multiple={false}
                    options={{
                      city_name: "City",
                      state_name: "State",
                      pincode : "Pincode",
                    }}
                    value={selectedFilter}
                    className="common_global_filter"
                    onChange={handleSelect}
                    nulloption="Select Filter Options"
                  />
                </Grid>
                <Grid>
                  <Grid item>
                    <CustomInput
                    onChange={(e) => OnHandleSearch(e)}
                    className="common_custom_input"
                    value={search}
                    placeholder="Enter Discription key"
                    />
                  </Grid>
                  <Grid>
                      {search ? <span style={{"color":"red",fontSize:'13px',position:'absolute'}}>{errorMessage}</span>: ""}
                    </Grid>
                </Grid>
                <Grid item>
                  <Button
                    disabled={(selectedFilter && search && !errorMessage)? false : true}
                    size="small"
                    variant="contained"
                    className="shadow-none common_kissht_btn"
                    color="primary"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item>
                  <Button onClick={refreshHandler} size="small" color="primary">
                    Reset
                  </Button>
                </Grid>
              </Grid>
            </Grid>
              </Grid>
            
          </Grid>
        </Toolbar>
      </Header>

      <div className="common_padding_from_title_withLessFilter">
        <Card
          style={{
            boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
          }}
        >
          <CardContent style={{ height: "50px" }}>
            <Grid container className="grid-vertical-align-center">
              <Grid item xs={12}>
                <p
                  className="text-xs"
                  style={{
                    color: Colors["lightPurple"],
                    margin: "auto",
                  }}
                ></p>
              </Grid>
            </Grid>
          </CardContent>
          <CardContent className='table_card_mobile'>
            <KisshtTable
              loading={spinning}
              columns={columns}
              data={pinData}
              onPageChange={onPageChange}
              showPagination={pinData.length > 0 ? true : false}
              offset={offset}
              totalCount={pinDataCount}
            />
          </CardContent>
        </Card>
        <AddEditPinModel 
        isEditing={isEditing}
        title="Add Pincode" 
        visible={openPincode}
        data={editData}
        onload
        handleDialogClick={()=>handleDialogClick()}
        handleDialogClose={() => handleToggleDialogClose()} props={props} />
        {openPinCodeModal && (
          <PinCodeViewModel
          data={showPinData}
          props={props}
            visible={openPinCodeModal}
            callbackEvent={handlePinCodeModalClosed}
          ></PinCodeViewModel>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, null)(PincodeList);
